// Material 3 loading indicator shapes, drawn as polar curves on a 48×48 box.
// Every path has the same number of points, so SVG can morph between any two.

export const LOADING_BOX = 48
const CENTER = LOADING_BOX / 2
const OUTER_RADIUS = 19 // 38px shape in a 48px box, as in the M3 spec
const POINTS = 72

export function polarShape(lobes: number, depth: number): string {
	const base = OUTER_RADIUS / (1 + depth)
	const points: string[] = []
	for (let i = 0; i < POINTS; i++) {
		const angle = (i / POINTS) * 2 * Math.PI
		const radius = base * (1 + depth * Math.cos(lobes * angle))
		// Start at the top so one lobe always points up.
		const x = CENTER + radius * Math.sin(angle)
		const y = CENTER - radius * Math.cos(angle)
		points.push(`${x.toFixed(2)},${y.toFixed(2)}`)
	}
	return `M${points.join('L')}Z`
}

// soft burst → 9-cookie → pentagon → pill → sunny → 4-cookie → oval → soft burst
export const LOADING_SHAPES: readonly string[] = [
	polarShape(10, 0.08),
	polarShape(9, 0.06),
	polarShape(5, 0.08),
	polarShape(2, 0.1),
	polarShape(8, 0.04),
	polarShape(4, 0.09),
	polarShape(2, 0.06),
	polarShape(10, 0.08),
]

export const STILL_SHAPE = LOADING_SHAPES[1]
